module.exports = __webpack_public_path__ + "img/icon-low-hanging-fruit.2317a039.svg";